import React, { Dispatch, SetStateAction } from "react";
import { Modal } from "antd";
import styled from "@emotion/styled";
import BasicButton from "@components/button/BasicButton";

const ModalContainer = styled(Modal)<{ padding: string }>(
  ({ theme, padding }) => ({
    fontFamily: "Pretendard ,Sans-serif",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    ".ant-modal-content": {
      borderRadius: "0",
      padding,
    },

    ".ant-modal-body": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      fontSize: "1.6rem",
      fontWeight: theme.fontWeight.medium,
      lineHeight: "1.6rem",
    },

    ".ant-modal-header": {
      textAlign: "center",
    },
  }),
);

const ButtonWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  marginTop: "3rem",
});

type Props = {
  children?: React.ReactNode;
  open: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>>;
  activeEvent?: () => void;
  closeEvent?: () => void;
  activeName?: string;
  closeName?: string;
  point?: boolean;
  noButton?: boolean;
  notice?: boolean;
  warning?: boolean;
  padding?: string;
  closeBorder?: boolean;
  closeIcon?: boolean;
  title?: string;
  closeModal?: () => void;
  maskClosable?: boolean;
};
const BasicModal = ({
  children,
  open,
  setOpen,
  activeEvent,
  activeName = "확인",
  closeEvent,
  closeName = "취소",
  noButton,
  notice,
  point = false,
  warning = false,
  padding = "5.6rem 1.6rem 2.4rem",
  closeBorder,
  closeIcon,
  title,
  maskClosable,
  closeModal,
}: Props) => {
  const handleClose = () => {
    if (closeModal) {
      closeModal();
    } else if (setOpen) {
      setOpen(false);
    }
  };

  return (
    <ModalContainer
      padding={padding}
      maskClosable={maskClosable}
      open={open}
      footer={
        !noButton && (
          <ButtonWrapper>
            <BasicButton
              title={activeName}
              point={point}
              warning={warning}
              onClick={activeEvent ? activeEvent : handleClose}
            />
            {!notice && (
              <BasicButton
                title={closeName}
                noBorder={!closeBorder}
                borderColor="#000000"
                outlined
                onClick={closeEvent ? closeEvent : handleClose}
              />
            )}
          </ButtonWrapper>
        )
      }
      closeIcon={closeIcon ? true : false}
      onCancel={closeModal}
      transitionName={""}
      maskTransitionName={""}
      title={title ? title : null}>
      {children}
    </ModalContainer>
  );
};

export default BasicModal;
